import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminEmployerProjects = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'admin/employer-projects',
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
